import { CreditApplication, CreditApplicationStatus } from '_gql'

import { GetPostLoginDecisionData } from '@sputnik/pages/PreApplicationPages/PostLoginPage/GetPostLoginDecisionData.gql'
import { MAJOR_ACCOUNT_CHANGE, PATHNAME_CONSTS } from '@sputnik/resources/constants'

export const getApplicationRedirectionRouting = ({
  salesforceCreditId,
  recordType,
}: Pick<CreditApplication, 'salesforceCreditId' | 'recordType'>) => {
  const defaultSection = PATHNAME_CONSTS.NAME_AND_OWNERSHIP_PATH
  const section = recordType === MAJOR_ACCOUNT_CHANGE ? PATHNAME_CONSTS.REVIEW_PATH : defaultSection
  const pathname = `/app/${salesforceCreditId}/${section}`

  return {
    pathname,
    autoRedirectIndex: section === defaultSection ? 0 : undefined,
  }
}

interface GetMatchingBdcCreditApplicationParams {
  creditApplications: NonNullable<GetPostLoginDecisionData['creditApplications']>
  bdcOrgIdParam?: string
}

export const getMatchingBdcCreditApplication = ({
  creditApplications,
  bdcOrgIdParam,
}: GetMatchingBdcCreditApplicationParams) =>
  creditApplications.find(({ bdcOrgId }) => bdcOrgId && bdcOrgId?.toLowerCase() === bdcOrgIdParam?.toLowerCase()) ||
  null

interface GetCreditApplicationParams {
  creditApplications: NonNullable<GetPostLoginDecisionData['creditApplications']>
  bdcOrgIdParam?: string
  creditIdParam?: string
  currentUserEmail: string | null
}

export const getRedirectableCreditApplication = ({
  creditApplications,
  bdcOrgIdParam,
  creditIdParam,
  currentUserEmail,
}: GetCreditApplicationParams) => {
  const matchingBdcApplication = getMatchingBdcCreditApplication({ creditApplications, bdcOrgIdParam })

  const matchingCreditApplication =
    matchingBdcApplication ||
    creditApplications.find(
      ({ salesforceCreditId }) => salesforceCreditId?.toLowerCase() === creditIdParam?.toLowerCase(),
    ) ||
    null

  const candidateCreditApplication = creditApplications.length === 1 ? creditApplications[0] : matchingCreditApplication

  const creditApplicationHasRedirectableStatus =
    candidateCreditApplication?.status === CreditApplicationStatus.NOT_STARTED ||
    candidateCreditApplication?.status === CreditApplicationStatus.IN_PROGRESS ||
    (candidateCreditApplication?.status === CreditApplicationStatus.AWAITING_SIGNATURE &&
      currentUserEmail?.toLowerCase() === candidateCreditApplication?.authorizedSigner?.email?.toLowerCase())

  if (creditApplicationHasRedirectableStatus) {
    return candidateCreditApplication
  }

  return null
}
